getApolloContext